module.exports = __webpack_public_path__ + "img/mj-logo-white.08a81613.svg";